// 引入富文本
import EditorBar from '@/components/wangeditor/wangeditor.vue';

export default {
    data() {
        return {
            // 文章标题
            articleTitle: '',
            // 文章分类
            articleType: '',
            options: [
                {
                    value: 1,
                    label: '政策法规'
                },
                {
                    value: 2,
                    label: '通知公告'
                }
            ],
            // 控制显示新增文章弹窗
            showAddArticle: false,
            // 文章对象
            article: {
                type: '',
                title: '',
                data: '',
            },
            // 每页显示条数
            pageSize: 15,
            // 当前页
            currentPage: 1,
            // 总条数
            total: 0,
            // 文章数组
            articleList: [],
            // 控制显示编辑文章弹窗
            showEditArticle: false,
            // 文章id
            articleId: '',
            // 控制显示查看已上传附件对话框
            showUploadedAccessory: false,
            // 上传的地址
            action: this.baseUrl + 'file/upload_file?token=' + this.$store.state.authority_management,
            // 附件数组
            accessoryList: [],
        };
    },
    methods: {
        // 富文本保存数据
        showMessageFromChild(data) {
            this.article.data = data;
        },

        // 验证表单内容
        validateForm() {
            if (this.$isAbnormal(this.article.type)) {
                this.$message.error('请选择文章分类');
                return false;
            }
            if (this.$isAbnormal(this.article.title)) {
                this.$message.error('请输入文章标题');
                return false;
            }
            if (this.$isAbnormal(this.article.data)) {
                this.$message.error('请输入文章内容并点击保存按钮');
                return false;
            }
            return true;
        },

        // 点击新增文章按钮
        handleAddArticle() {
            // 验证表单内容
            if (this.validateForm()) {
                // 新增文章
                this.addArticle();
            }

        },

        // 新增文章
        addArticle() {
            this.$post('article/insert', {
                token: this.$store.state.authority_management,
                title: this.article.title,
                data: this.article.data,
                type: this.article.type,
                shop_id: this.$store.state.store.id
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('添加文章成功');
                } else {
                    this.$message.success('添加文章失败，请重试');
                }
                // 隐藏新增文章弹窗
                this.showAddArticle = false;
                // 清空文章对象的属性值
                this.clearValue();
                // 重新拉取数据
                this.getData();
            })
        },

        // 获取文章列表
        getData() {
            this.$post('article/search', {
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                title: this.articleTitle,
                type: this.articleType,
                shop_id: this.$store.state.store.id
            }).then(res => {
                this.articleList = res.data.result.data;
                this.total = res.data.result.total;
            })
        },

        //搜索
        search() {
            this.currentPage = 1;
            this.$post('article/search', {
                offset: 0,
                length: this.pageSize,
                title: this.articleTitle,
                type: this.articleType,
                shop_id: this.$store.state.store.id
            }).then(res => {
                this.articleList = res.data.result.data;
                this.total = res.data.result.total;
            })
        },

        // 清空文章对象的属性值
        clearValue() {
            this.article.title = '';
            this.article.data = '';
            this.article.type = '';
        },

        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 获取文章类型
        getType(type) {
            if (type === 1) {
                return '政策法规';
            } else if (type === 2) {
                return '通知公告';
            }
        },

        // 处理点击编辑按钮
        edit(id) {
            this.showEditArticle = true;
            this.articleId = id;

            // 根据id获取文章
            this.getArticleById(id);
        },

        // 处理点击删除按钮
        remove(id) {
            this.$confirm('确认删除该文章?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除文章
                this.deleteArticle(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 弹窗关闭调用的方法
        close() {
            this.showAddArticle = false;
            this.showEditArticle = false;
            this.clearValue();
        },

        // 处理点击修改文章按钮
        handleEditArticle() {
            // 验证表单内容
            if (this.validateForm()) {
                // 修改文章
                this.editArticle();
            }
        },

        // 修改文章
        editArticle() {
            this.$post('article/update', {
                token: this.$store.state.authority_management,
                id: this.articleId,
                title: this.article.title,
                data: this.article.data,
                type: this.article.type,
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('修改文章成功');
                } else {
                    this.$message.error('修改文章失败，请稍后重试')
                }
                this.showEditArticle = false;
                this.clearValue();
                this.getData();
            })
        },

        // 获取文章
        getArticleById(id) {
            this.$post('article/get', {
                id: id
            }).then(res => {
                this.article = res.data.result;
            })
        },

        // 删除文章
        deleteArticle(id) {
            this.$post('article/delete', {
                token: this.$store.state.authority_management,
                id: id
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('删除文章成功');
                } else {
                    this.$message.error('删除文章失败，请稍后重试')
                }
                this.clearValue();
                this.getData();
            })
        },

        // 上传文件
        httpreq(q) {
            this.$upload(this.action, q).then(res => {
                if (res.data.status == 'success') {
                    this.$message.success('上传成功！');
                    // 添加上传的附件
                    this.insertAccessory(q.file.name, res.data.result);
                }
            });
        },

        // 插入附件
        insertAccessory(fileName, filePath) {
            this.$post('accessory/insert', {
                token: this.$store.state.authority_management,
                filename: fileName,
                file_path: filePath,
            }).then(() => {
                this.selectAccessory();
            });
        },

        // 查询所有附件
        selectAccessory() {
            this.$post('accessory/search', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 9999
            }).then(res => {
                this.accessoryList = res.data.result.data;
            });
        }
    },
    components: {
        EditorBar
    },
    created() {
        this.getData();
        this.selectAccessory();
    }
};
